import { useTranslation } from '@e-kyc/translations';

import {
  Button,
  CameraAltOutlinedIcon,
  CheckCircleRoundedIcon,
  IdentifyProgressBar,
} from '../../../../components';
import { useEkyc } from '../../../../providers';

export default function CaptureFaceInstructionPage() {
  const { t } = useTranslation();
  const { setStep } = useEkyc();

  return (
    <div className='flex h-dvh w-full flex-col items-center justify-center'>
      <div className='flex size-full max-w-md flex-col items-start justify-between'>
        <div className='flex flex-col overflow-auto'>
          <IdentifyProgressBar currentStep={3} />
          <div className='flex w-full flex-col items-center gap-4 p-4'>
            <h4 className='w-full'>{t('capture.face.instruction.title')}</h4>
            <div className='flex w-full flex-col items-start gap-3'>
              <div className='flex items-center gap-2'>
                <CheckCircleRoundedIcon className='text-success-500 text-xl' />
                <div className='flex w-full flex-col items-start gap-1'>
                  <div className='text-body2 font-semibold'>
                    {t('capture.face.instruction.1.title')}
                  </div>
                  <div className='text-text-secondary text-body2'>
                    {t('capture.face.instruction.1.description')}
                  </div>
                </div>
              </div>
              <div className='flex items-center gap-2'>
                <CheckCircleRoundedIcon className='text-success-500 text-xl' />

                <div className='flex w-full flex-col items-start gap-1'>
                  <div className='text-body2 font-semibold'>
                    {t('capture.face.instruction.2.title')}
                  </div>
                  <div className='text-text-secondary text-body2'>
                    {t('capture.face.instruction.2.description')}
                  </div>
                </div>
              </div>
              <div className='flex items-center gap-2'>
                <CheckCircleRoundedIcon className='text-success-500 text-xl' />

                <div className='flex w-full flex-col items-start gap-1'>
                  <div className='text-body2 font-semibold'>
                    {t('capture.face.instruction.3.title')}
                  </div>
                  <div className='text-text-secondary text-body2'>
                    {t('capture.face.instruction.3.description')}
                  </div>
                </div>
              </div>
            </div>
            <img src='face_graphic.png' alt='face graphic' />
          </div>
        </div>
        <div className='sticky bottom-0 flex w-full items-center justify-center bg-white p-4 pb-8'>
          <Button
            className='flex w-full items-center justify-center gap-2'
            onClick={() => setStep('capture-face')}
          >
            <CameraAltOutlinedIcon className='text-2xl' />
            {t('capture.instruction.button')}
          </Button>
        </div>
      </div>
    </div>
  );
}
